"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { EcommerceProductsProvider, useEcommerceProducts } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function ProductsCarouselConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <Carousel opts={{
      align: "start"
    }} className="w-full">
        <CarouselContent>
          {[...Array(4)].map((_, i) => <CarouselItem key={i} data-index={i} className="md:basis-1/2 lg:basis-1/3 pl-4">
              <Card className="rounded-[8px] border-none shadow-lg overflow-hidden h-full">
                <CardContent className="p-4 flex flex-col gap-4 h-full">
                  <div className="w-full aspect-square bg-muted/20 animate-pulse rounded-lg" />
                  <div className="h-6 bg-muted/20 animate-pulse rounded w-3/4" />
                  <div className="h-4 bg-muted/20 animate-pulse rounded w-1/2" />
                  <div className="mt-auto h-10 bg-muted/20 animate-pulse rounded w-full" />
                </CardContent>
              </Card>
            </CarouselItem>)}
        </CarouselContent>
      </Carousel>;
  }
  if (error || products.length === 0) {
    return <div data-section-id="155828" className="text-muted-foreground text-center p-8 bg-muted/30 rounded-2xl">
        <p>No specialist profiles available at this moment.</p>
      </div>;
  }
  return <Carousel opts={{
    align: "start"
  }} className="w-full">
      <CarouselContent className="-ml-4">
        {products.map((product, i) => <CarouselItem key={product.id} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
            <Card className="rounded-[8px] border border-border/40 shadow-lg bg-card text-card-foreground h-full flex flex-col overflow-hidden transition-all hover:shadow-xl hover:-translate-y-1 duration-300">
              <CardContent className="p-4 flex flex-col flex-grow gap-4">
                <Link to={product.link} className="block group">
                  <AspectRatio ratio={1} className="bg-muted rounded-md overflow-hidden">
                    {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center bg-accent/20 text-accent-foreground">
                        <span className="text-xs font-semibold uppercase tracking-wider">Staffing Profile</span>
                      </div>}
                  </AspectRatio>
                </Link>
                
                <div className="flex flex-col flex-grow">
                  <Link to={product.link} className="hover:text-primary transition-colors">
                    <h3 className="font-sans font-bold text-lg line-clamp-2 leading-tight text-primary">
                      {product.title}
                    </h3>
                  </Link>
                  
                  {product.price !== undefined && <div className="mt-2 mb-4">
                      <span className="text-base font-semibold text-accent-foreground">
                        Staffing Rates Available
                      </span>
                    </div>}
                  
                  <div className="mt-auto pt-4">
                    <Link to="/facilities/" className="bg-gradient-to-r from-[#1E4FA3] to-[#0A2E6E] text-white w-full rounded-[8px] font-semibold py-3 shadow-md hover:shadow-lg hover:opacity-95 transition-all inline-flex items-center justify-center">
                      Request Coverage
                    </Link>
                  </div>
                </div>
              </CardContent>
            </Card>
          </CarouselItem>)}
      </CarouselContent>
      <div className="hidden md:block">
        <CarouselPrevious className="bg-gradient-to-r from-[#1E4FA3] to-[#0A2E6E] text-white hover:opacity-90 border-none shadow-sm -left-4" />
        <CarouselNext className="bg-gradient-to-r from-[#1E4FA3] to-[#0A2E6E] text-white hover:opacity-90 border-none shadow-sm -right-4" />
      </div>
    </Carousel>;
}
export default function SalesBoost() {
  const wp_query_params = {
    per_page: 6,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}